import { graphql, useStaticQuery } from "gatsby"
import { useMemo, useCallback } from "react"

export const useProductBadges = () => {
  const { badge } = useStaticQuery<GatsbyTypes.SettingProductBadgesQuery>(graphql`
    query SettingProductBadges {
      badge: allSanitySettingProductBadges {
        edges {
          node {
            _key
            name
            tags
            color {
              preset
              custom {
                hex
              }
            }
            textColor
            hideText
          }
        }
      }
    }
  `)

  const normalisedBadge = useMemo(() => badge?.edges?.map((edge: any) => edge?.node), [badge])

  const getBadgesByTags = useCallback(
    (tags: string[]) => normalisedBadge?.filter((badge: any) => tags?.some(tag => badge.tags.includes(tag))),
    [normalisedBadge]
  )

  return {
    getBadgesByTags,
  }
}
